<div class="container">
  <!-- Component Key Onboarding Form-->
  <form [hidden]="loading" [formGroup]="transitTimeOnboardingForm" (ngSubmit)="submit()"
        class="pure-form pure-form-stacked">

    <!-- Select option for From Country Code Options -->
    <div class="pure-control-group">
      <label for="fromCountryCodeId">From Country Code
        <app-popover [message]="help_messages.from_country_code"></app-popover>
      </label>
      <select id="fromCountryCodeId" class="pure-input-2-3"
              formControlName="fromCountryCode">
        <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                [value]="_fromCountryCode">
          {{ _fromCountryCode }}
        </option>
      </select>
    </div>

    <div class="pure-control-group">
      <label for="businessUseCase">Business Use Case
        <app-popover [message]="help_messages.business_unit"></app-popover>
      </label>
      <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase"
              #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
        <ng-template ngFor let-item [ngForOf]="getItems">
          <optgroup label="{{item.name}}">
            <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
              {{usecase.text}}
            </option>
          </optgroup>
        </ng-template>
      </select>
    </div>

    <!-- Read only text for displaying onboarded component key placeholder-->
    <label for="componentKeyPlaceholderId">Level Of Data
      <app-popover [message]="help_messages.level_of_data"></app-popover>
    </label>
    <input id="componentKeyPlaceholderId" class="pure-input-2-3" type="text"
           formControlName="componentKeyPlaceholder" readonly/>

    <!-- Dynamic entries for Component Key Place holder parts -->
    <form [formGroup]="transitTimeOnboardingForm.get('componentKeyValue')">
      <div *ngFor="let field of currentComponentKeyPlaceholder;let i = index">
        <label for="{{'componentKeyValue'+i}}">{{field}}</label>
        <input type="text" [formControlName]="field" class="pure-input-2-3" id="{{'componentKeyValue'+i}}"/>
      </div>
    </form>

    <div [hidden]="singleTransitTimeColumns.length == 0">
      <label for="schema">Required Schema Format of the Transit Time Files for the selected Business use case
        <app-popover [message]="help_messages.expected_schema"></app-popover>
      </label>
      <div id="schema" class="p-3 mb-2 text-dark">
        <app-table [label]="single" [header]="singleTransitTimeColumns"></app-table>
        <app-table [label]="range" [header]="rangeTransitTimeColumns"></app-table>
      </div>
    </div>

    <div [hidden]="(this.commonUtils.getArc() == 'OOC') || transitTimeOnboardingForm.get('lookUpKeys')['controls'].length == 0">
      <label>Select the pattern for columns (Optional):
        <app-popover [message]="help_messages.pattern"></app-popover>
      </label>
      <div class="pure-form pure-form-stacked" formArrayName="lookUpKeys"
           *ngFor="let key of transitTimeOnboardingForm.get('lookUpKeys')['controls']; let i = index">
        <div [formGroupName]="i" [hidden]="!key.value.name.includes('ZIP')">
          <label for="{{'regexId' + i}}"><i>{{ i + 1 }}</i>: <b>{{key.value.name}}</b> </label>
          <select id="{{'regexId' + i}}" formControlName="regex">
            <option *ngFor=" let _pattern of patternOptions; let i = index " [value]="_pattern">
              {{ _pattern }}
            </option>
          </select>
        </div>
        <div [formGroupName]="i" [hidden]="key.value.name.includes('ZIP')">
          <i>{{ i + 1 }}</i>: <b>{{key.value.name}} (Pattern not applicable)</b>
        </div>
      </div>
    </div>

    <label for="transitTimeTypeId">Select Transit Time Type
      <app-popover [message]="help_messages.transit_time_type"></app-popover>
    </label>
    <select formControlName="transitTimeType" id="transitTimeTypeId" class="pure-input-2-3">
      <option *ngFor=" let _transitTime of transitTimeOptions; let i = index " [value]="_transitTime">
        {{ _transitTime }}
      </option>
    </select>

    <div>
      <label for="fileUpload">Upload File
        <app-popover [message]="help_messages.file"></app-popover>
      </label>
      <input type="file" formControlName="transitTimeFile" (change)="onFileChange($event)" class="pure-input-2-3"
             id="fileUpload" accept=".tsv">
    </div>

    <!-- Submit button-->
    <div>
      <button class="pure-button pure-button-primary button-large" type="submit"
              [disabled]="transitTimeOnboardingForm.invalid || (progress > 0 && progress < 100)">Submit
      </button>
    </div>
  </form>
  <div class="progress" *ngIf="progress > 0">
    <div class="progress-bar progress-bar-animated progress-bar-striped bg-success" role="progressbar"
         [style.width.%]="progress">{{progress}}%
    </div>
  </div>
  <app-loader [loading]="loading" [size]="'small'"></app-loader>
</div>
